import { map } from 'rxjs/operators'

import { get, post, put } from 'utils/rxfetch'

// Live email-encryption branding settings API. Company scoping uses the same
// `?companyFilter=` mechanism (PartnerSwapPermission) as the sibling
// email-encryption settings endpoints.
const BASE = '/members-api/oes-management-proxy/branding/'

export const getEmailEncryptionBranding = (companyId) => get(`${BASE}?companyFilter=${companyId}`)

export const updateEmailEncryptionBranding = (companyId, payload) =>
  put(`${BASE}?companyFilter=${companyId}`, payload).pipe(map((res) => res.response))
export const getBrandingAsset = (companyId, kind) =>
  get(`${BASE}assets/${kind}/?companyFilter=${companyId}`)

const imagesUrl = (kind, action, companyId) =>
  `${BASE}images/${kind}/${action}/?companyFilter=${companyId}`

export const presignBrandingImage = (companyId, kind, body) =>
  post(imagesUrl(kind, 'presign', companyId), body).pipe(map((res) => res.response))

export const verifyBrandingImage = (companyId, kind, body) =>
  post(imagesUrl(kind, 'verify', companyId), body).pipe(map((res) => res.response))
